<template>
  <vs-popup class="confirm-work-order-pop-up"
            title="CONFIRMED TO MANUFACTURING PLAN"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <span v-for="(error, index) in stock_errors" :key="index" class="text-danger">
       {{ index + 1 }} - {{ error }} <br>
      </span>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="confirm-work-order-pop-up" @submit.prevent="handleSubmit(onClickConfirmWorkOrder)" autocomplete="off">
             <div class="vx-row mb-3 mt-2">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="work_order_date" name="work_order_date" rules="required" v-slot="{ errors }">
                  <small class="label">Work Order Date</small>
                  <flat-pickr
                    :config="{dateFormat: 'd/m/Y', minDate: 'today'}"
                    class="hidden"
                    v-model="form.work_order_date"
                    placeholder="Choose Date"/>

                  <flat-pickr :config="{dateFormat: 'd/m/Y', minDate: 'today'}" class="w-full" v-model="form.work_order_date"
                              placeholder="Choose Manufacturing Date"/>
                </ValidationProvider>
              </div>
            </div>
          <vs-list class="my-2">
            <vs-list-item v-if="taken_slots.length === 0 && form.work_order_date" title="There is no time slots taken by this product line"></vs-list-item>
            <vs-list-item v-for="(slot, index) in taken_slots" :key="index" :title="slot.work_order_code" :subtitle="'Start Time ' + __utcToLocalTime(slot.start_time)+'h' + ' - End Time ' + __utcToLocalTime(slot.end_time)+'h'"></vs-list-item>
          </vs-list>
            <div class="vx-row mb-3 mt-2">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="start_time" name="start_time" rules="required" v-slot="{ errors }">
                  <small class="label">Start Time</small>
                  <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true,  minTime: min_time}" class="w-full" v-model="form.start_time"
                              placeholder="Choose Time"/>
                </ValidationProvider>
              </div>
            </div>

          <div class="vx-row mb-3 mt-2" v-if="taken_slots.length > 0">
            <div class="vx-col md:w-full w-full md:mb-0">
              <vs-alert active="true" class="h-full" color="danger">
                If you select a time that already has a committed work order. You will be allocated the next available time slot on this production line
              </vs-alert>
            </div>
          </div>

            <div class="flex flex-wrap items-center justify-end mt-8" >
              <vs-button :disabled="stock_errors.length > 0" id="save_change_button" button="submit" class="ml-auto mt-2">Confirm</vs-button>
              <vs-button @click="open =false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>
            </div>

        </form>
      </ValidationObserver>

    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const ManufacturingRepository = RepositoryFactory.get('manufacturing')
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import moment from 'moment'

  function initialState() {
    return {
      open: false,
      createForm: {},
      form: {},
      id: '',
      production_line_id: '',
      taken_slots: [],
      min_time: "09:00",
      stock_errors: []
    }
  }

export default {
  name: 'ConfirmWorkOrderPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id, production_line_id) {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.id = id
        this.production_line_id = production_line_id
        await this.checkStock()
        this.open = true;
      } catch (error) {

      }
    },

    async onClickConfirmWorkOrder (){
      const vue = this
      await this.$vs.loading({
        container: '#confirm-work-order-pop-up',
        scale: 0.45
      })
       try {
         const payload = {}
         Object.assign(payload, this.form)
         payload.start_time = moment(payload.start_time, 'HH:mm').utc().format('HH:mm')
         await ManufacturingRepository.workOrderStatusChange(this.id, 'confirm', payload)
         this.showSuccessMessage('Work order confirmed successfully')
         this.open = false;
         await vue.$parent.refreshData()
         this.$vs.loading.close('#confirm-work-order-pop-up > .con-vs-loading')
       }catch (e) {
         this.$vs.loading.close('#confirm-work-order-pop-up > .con-vs-loading')
         this.convertAndNotifyError(e)
       }
    },
    onChangeDate() {

    },
    async checkTimeSlots(date) {
      await this.$vs.loading({
        container: '#confirm-work-order-pop-up',
        scale: 0.45
      })
      try {
        const { data } = (await ManufacturingRepository.getProductionLineTakenTimeSlots(this.production_line_id, date)).data
        this.taken_slots = data
      } catch (e) {

      }
      this.$vs.loading.close('#confirm-work-order-pop-up > .con-vs-loading')
    },
    onChange(selectedDates, dateStr, instance) {

    },
    async checkStock() {
      try {
        const data = await ManufacturingRepository.getWorkOrderStock(this.id)
      } catch (error) {
        if(error.response.data.data.length > 0){
          this.stock_errors = error.response.data.data
        }
      }
    }

  },
  computed: {
    test: function () {
      return moment(this.form.start_time, 'HH:mm').utc().format('HH:mm')
    }
  },
  watch: {
    'form.work_order_date': {
      handler: function (after, before) {
        this.checkTimeSlots(after)
        const b = moment().format('DD/MM/YYYY')
        if (after === b) {
          this.min_time = moment().format('HH:mm')
        } else {
          this.min_time = "09:00"
        }
      },
      deep: true
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
    flatPickr
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .confirm-work-order-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }

</style>
